import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

type V2PublicAuthShellProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

const V2PublicAuthShell: React.FC<V2PublicAuthShellProps> = ({
  title,
  subtitle,
  children,
  footer,
}) => (
  <div className="v2-theme" data-page="auth">
    <a className="skip-link" href="#main">
      К содержимому
    </a>
    <header className="public-header shell">
      <Link className="brand" to="/" aria-label="Fish Hunter — главная">
        <img src={logo} alt="Fish Hunter" />
      </Link>
      <nav className="public-nav" aria-label="Главная навигация">
        <Link to="/subscription">Тарифы</Link>
        <Link to="/faq">FAQ</Link>
      </nav>
      <Link className="header-login outline-button" to="/">
        Войти <span aria-hidden="true">↗</span>
      </Link>
    </header>

    <main className="landing shell auth-main" id="main">
      <section className="login-card auth-card" aria-labelledby="auth-title">
        <div className="login-kicker">
          <span className="eyebrow">FISH HUNTER</span>
          <span className="large-arrow" aria-hidden="true">
            ↗
          </span>
        </div>
        <h2 id="auth-title">{title}</h2>
        {subtitle ? <p className="login-subtitle">{subtitle}</p> : null}
        {children}
        {footer}
      </section>
    </main>

    <footer className="public-footer shell">
      <span>
        FISH HUNTER <span className="muted">© 2026</span>
      </span>
      <Link to="/">На главную ↗</Link>
    </footer>
  </div>
);

export default V2PublicAuthShell;
